import { Phone } from "lucide-react";
import { Button } from "../ui/button";

export default function CallButton ({ phone = "09192387002" }){
    return(
        <a href={`tel:${phone}`}>
            <Button variant="berry" size="xl">
              تماس با ما
              <Phone size={24} />
            </Button>
        </a>
    )
}